import { useEffect } from "react";

function setMeta(name, content) {
  let el = document.head.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

function setProp(prop, content) {
  let el = document.head.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Client-side head manager. Server-rendered snapshots with the same tags live at /api/ssr/...
 * Social cards: og:image / twitter:image are the static brand images set in public/index.html; here we keep
 * title, description and URL in sync so shared links show the right page text with the LUX card.
 */
const DEFAULT_IMAGE = `${process.env.REACT_APP_BACKEND_URL || ""}/og-image.png`;

export function useSeo({ title, description, canonical, robots, image } = {}) {
  useEffect(() => {
    // Social card: per-page image when provided (e.g. a profile's share card), otherwise the LUX brand card
    setProp("og:image", image || DEFAULT_IMAGE);
    setProp("og:image:secure_url", image || DEFAULT_IMAGE);
    setMeta("twitter:image", image || DEFAULT_IMAGE);
    if (title) {
      document.title = title;
      setProp("og:title", title);
      setMeta("twitter:title", title);
    }
    if (description) {
      setMeta("description", description);
      setProp("og:description", description);
      setMeta("twitter:description", description);
    }
    setMeta("robots", robots || "index,follow");
    setCanonical(canonical);
    setProp("og:url", canonical || window.location.href.split("?")[0]);
  }, [title, description, canonical, robots, image]);
}

export const PRIVATE_SEO = { robots: "noindex,nofollow" };
